import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-page-content',
  standalone: false,
  styleUrls: ['./page-content.component.scss'],
  templateUrl: './page-content.component.html'
})
export class PageContentComponent {
  @Input() scrollX = true;
  @Input() scrollY = true;
  @Input() paddingBottom = false;
}
